// extracted by mini-css-extract-plugin
export var education = "style-module--education--dfa69";
export var education__block = "style-module--education__block--3dc46";
export var education__blockText = "style-module--education__block-text--52234";
export var education__blocks = "style-module--education__blocks--00a55";
export var education__title = "style-module--education__title--6c739";